const OTP_EXPIRY_SECONDS = 600;
const OTP_RESEND_SECONDS = 30;
const OTP_CHANNEL_EMAIL = 'email';
const OTP_CHANNEL_SMS = 'sms';
const SOURCE_RETURNS = 'returns';


export { OTP_CHANNEL_EMAIL, OTP_CHANNEL_SMS, OTP_EXPIRY_SECONDS, OTP_RESEND_SECONDS, SOURCE_RETURNS };